<template>
  <section @click="stopShow($event)" id="cander" style="font-size: 12px">
    <section class="canderInput" :style="{'width' : domWidth}">
      <section class="canderInputPlace">
        <input :disabled="newDisabled" readonly="readonly" @focus="showCanderFun()" @blur="hiddenChoose($event)" :value="fatherDate[0] && fatherDate[1] ? ((fatherDate[0] || '') + '-' + (fatherDate[1] || '')) : ''" :class="className" type="text" :placeholder="placeholderName" style="width: 100%;">
        <b v-if="!newDisabled" @click="removeValue">X</b>
      </section>
      <section>
        <section style="left: 0px;border-left: 1px solid #eee;border-bottom: 1px solid #eee;border-top: 1px solid #eee" :id="randomId" class="canderDiv">
          <section class="canderHeader">
            <span @click="prevYear()"><b style="margin-right: -5px">＜</b><b>＜</b></span>
            <span @click="prevMonth()"><b>＜ </b></span>
            <span class="headerTitle"><b>{{nowYear}}年{{nowMonth}}月</b></span>
            <span v-if="canclick" @click="nextMonth()"><b>＞</b></span>
            <span v-else><b>＞</b></span>
            <span v-if="canclick" @click="nextYear()"><b style="margin-right: -5px">＞</b><b>＞</b></span>
            <span v-else><b style="margin-right: -5px">＞</b><b>＞</b></span>
          </section>
          <section class="canderBody">
            <section><span>日</span><span>一</span><span>二</span><span>三</span><span>四</span><span>五</span><span>六</span>
            </section>
            <section class="canderBodyDate">
              <span @click="chooseDate(item)"  :style="{'color': item.isLast? '#eee' : '' ,'background' :  item.disabled? '#f3f3f3' : '' }" :class="returnChooseClass(item)" :key="index" v-for="(item, index) in dataTimeList">{{item.nowNum}}</span>
            </section>
            <section class="showTimePlace" v-if="showTimePicker">
              <select @change="changeChooseDate" v-model="newHour" class="canderHour">
                <option value="00">00</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
              </select>
              <select @change="changeChooseDate" v-model="newMinite" class="canderMin">
                <option value="00">00</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
                <option value="32">32</option>
                <option value="33">33</option>
                <option value="34">34</option>
                <option value="35">35</option>
                <option value="36">36</option>
                <option value="37">37</option>
                <option value="38">38</option>
                <option value="39">39</option>
                <option value="40">40</option>
                <option value="41">41</option>
                <option value="42">42</option>
                <option value="43">43</option>
                <option value="44">44</option>
                <option value="45">45</option>
                <option value="46">46</option>
                <option value="47">47</option>
                <option value="48">48</option>
                <option value="49">49</option>
                <option value="50">50</option>
                <option value="51">51</option>
                <option value="52">52</option>
                <option value="53">53</option>
                <option value="54">54</option>
                <option value="55">55</option>
                <option value="56">56</option>
                <option value="57">57</option>
                <option value="58">58</option>
                <option value="59">59</option>
              </select>
              <select @change="changeChooseDate" v-model="newDate" class="canderDate">
                <option value="00">00</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
                <option value="32">32</option>
                <option value="33">33</option>
                <option value="34">34</option>
                <option value="35">35</option>
                <option value="36">36</option>
                <option value="37">37</option>
                <option value="38">38</option>
                <option value="39">39</option>
                <option value="40">40</option>
                <option value="41">41</option>
                <option value="42">42</option>
                <option value="43">43</option>
                <option value="44">44</option>
                <option value="45">45</option>
                <option value="46">46</option>
                <option value="47">47</option>
                <option value="48">48</option>
                <option value="49">49</option>
                <option value="50">50</option>
                <option value="51">51</option>
                <option value="52">52</option>
                <option value="53">53</option>
                <option value="54">54</option>
                <option value="55">55</option>
                <option value="56">56</option>
                <option value="57">57</option>
                <option value="58">58</option>
                <option value="59">59</option>
              </select>
            </section>
            <section class="confirmButton" style="padding: 10px 0" v-if="showTimePicker">
              <button style="visibility: hidden" @click="chooseDateConfirm" class="suerButton"><abbr class="font12">确定</abbr></button>
            </section>
          </section>
        </section>
        <section style="left: 210px;border-right: 1px solid #eee;border-bottom: 1px solid #eee;border-top: 1px solid #eeeeee" :id="randomId + '2'" class="canderDiv">
          <section class="canderHeader">
            <span v-if="canclick" @click="prevYear2()"><b style="margin-right: -5px">＜</b><b>＜</b></span>
            <span v-else><b style="margin-right: -5px">＜</b><b>＜</b></span>
            <span v-if="canclick" @click="prevMonth2()"><b>＜ </b></span>
            <span v-else><b>＜ </b></span>
            <span class="headerTitle"><b>{{nowYear2}}年{{nowMonth2}}月</b></span>
            <span @click="nextMonth2()"><b>＞</b></span>
            <span @click="nextYear2()"><b style="margin-right: -5px">＞</b><b>＞</b></span>
          </section>
          <section class="canderBody">
            <section><span>日</span><span>一</span><span>二</span><span>三</span><span>四</span><span>五</span><span>六</span>
            </section>
            <section class="canderBodyDate">
              <span @click="chooseDate2(item)"  :style="{'color': item.isLast? '#eee' : '' ,'background' :  item.disabled? '#f3f3f3' : '' }" :class="returnChooseClass(item)" :key="index" v-for="(item, index) in dataTimeList2">{{item.nowNum}}</span>
            </section>
            <section class="showTimePlace" v-if="showTimePicker">
              <select @change="changeChooseDate2" v-model="newHour2" class="canderHour">
                <option value="00">00</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
              </select>
              <select @change="changeChooseDate2" v-model="newMinite2" class="canderMin">
                <option value="00">00</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
                <option value="32">32</option>
                <option value="33">33</option>
                <option value="34">34</option>
                <option value="35">35</option>
                <option value="36">36</option>
                <option value="37">37</option>
                <option value="38">38</option>
                <option value="39">39</option>
                <option value="40">40</option>
                <option value="41">41</option>
                <option value="42">42</option>
                <option value="43">43</option>
                <option value="44">44</option>
                <option value="45">45</option>
                <option value="46">46</option>
                <option value="47">47</option>
                <option value="48">48</option>
                <option value="49">49</option>
                <option value="50">50</option>
                <option value="51">51</option>
                <option value="52">52</option>
                <option value="53">53</option>
                <option value="54">54</option>
                <option value="55">55</option>
                <option value="56">56</option>
                <option value="57">57</option>
                <option value="58">58</option>
                <option value="59">59</option>
              </select>
              <select @change="changeChooseDate2" v-model="newDate2" class="canderDate">
                <option value="00">00</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
                <option value="13">13</option>
                <option value="14">14</option>
                <option value="15">15</option>
                <option value="16">16</option>
                <option value="17">17</option>
                <option value="18">18</option>
                <option value="19">19</option>
                <option value="20">20</option>
                <option value="21">21</option>
                <option value="22">22</option>
                <option value="23">23</option>
                <option value="24">24</option>
                <option value="25">25</option>
                <option value="26">26</option>
                <option value="27">27</option>
                <option value="28">28</option>
                <option value="29">29</option>
                <option value="30">30</option>
                <option value="31">31</option>
                <option value="32">32</option>
                <option value="33">33</option>
                <option value="34">34</option>
                <option value="35">35</option>
                <option value="36">36</option>
                <option value="37">37</option>
                <option value="38">38</option>
                <option value="39">39</option>
                <option value="40">40</option>
                <option value="41">41</option>
                <option value="42">42</option>
                <option value="43">43</option>
                <option value="44">44</option>
                <option value="45">45</option>
                <option value="46">46</option>
                <option value="47">47</option>
                <option value="48">48</option>
                <option value="49">49</option>
                <option value="50">50</option>
                <option value="51">51</option>
                <option value="52">52</option>
                <option value="53">53</option>
                <option value="54">54</option>
                <option value="55">55</option>
                <option value="56">56</option>
                <option value="57">57</option>
                <option value="58">58</option>
                <option value="59">59</option>
              </select>
            </section>
            <section class="confirmButton" style="padding: 10px 0" v-if="showTimePicker">
              <button style="position: relative;left: -105px" @click="chooseDateConfirm" class="suerButton"><abbr class="font12">确定</abbr></button>
            </section>
          </section>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
export default {
  name: 'cander',
  model: {
    prop: 'fatherDate',
    event: 'fatherDate'
  },
  props: [
    'needReplaceToday',
    'minDate',
    'fatherDate',
    'className',
    'showTimePicker',
    'placeholderName',
    'newWidth',
    'disabled',
    'canNotEqure'
  ],
  data () {
    return {
      chooseNowDate: '',
      chooseNowDate2: '',
      chooseSelectDate: '',
      chooseSelectDate2: '',
      domWidth: this.newWidth,
      newDisabled: this.disabled,
      newMinDate: this.minDate,
      randomId: 'cander' + new Date().getTime() + Math.random() * 1000,
      showCander: false,
      canclick: false,
      nowYear: 2019,
      nowYear2: 2019,
      nowMonth: 1,
      nowMonth2: 1,
      nowDate: new Date(),
      nowDate2: new Date(),
      dataTimeList: [],
      dataTimeList2: [],
      newHour: '00',
      newHour2: '00',
      newMinite: '00',
      newMinite2: '00',
      newDate: '00',
      newDate2: '00'
    }
  },
  watch: {
    newWidth (value) {
      this.domWidth = value
    },
    disabled (value) {
      this.newDisabled = value
    },
    minDate (value) {
      this.newMinDate = value
      if (this.nowDate) {
        let year = this.nowDate.getFullYear()
        let month = this.nowDate.getMonth() + 1
        const date = this.nowDate.getDate()
        this.replaceNewDate(year + '/' + month + '/' + date)
        if (this.fatherDate !== '' && this.fatherDate !== undefined && this.fatherDate !== null) {
          if (new Date(this.fatherDate.replace(/-/g, '/')).getTime() < new Date(this.newMinDate.replace(/-/g, '/')).getTime()) {
            this.$emit('fatherDate', '')
          }
        }
      }
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
    this.replaceNewDate(null, true)
    console.log(this.newWidth)
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    document.getElementById('index').onclick = function () {
      let canderList = document.querySelectorAll('.canderDiv')
      for (let i = 0; i < canderList.length; i++) {
        canderList[i].style.display = 'none'
      }
    }
  },
  methods: { // 所有的方法封装
    chooseDateConfirm () {
      if (this.chooseSelectDate && this.chooseSelectDate2) {
        if (this.minDate) {
          console.log(this.chooseSelectDate)
          if (new Date(this.minDate.replace(/-/g, '/')).getTime() < new Date().getTime() && new Date(this.chooseSelectDate.replace(/-/g, '/')).getTime() < new Date().getTime() && new Date(this.chooseSelectDate.replace(/-/g, '/')).getTime() > new Date(this.minDate.replace(/-/g, '/')).getTime()) {
            if (this.needReplaceToday) {
              this.$emit('fatherDate', [this.$commonJs.todayDate + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate, this.$commonJs.todayDate + ' ' + this.newHour2 + ':' + this.newMinite2 + ':' + this.newDate2])
              document.getElementById(this.randomId).style.display = 'none'
              document.getElementById(this.randomId + '2').style.display = 'none'
              return
            }
          } else {
            if (this.canNotEqure) {
              console.log(1)
              if (new Date(this.minDate.replace(/-/g, '/')).getTime() > new Date(this.chooseSelectDate.replace(/-/g, '/')).getTime()) {
                this.$commonJs.alertTips({
                  type: 'warning',
                  title: '提示',
                  content: '结束时间不能小于开始时间',
                  stayTime: 5
                })
                return
              }
            } else {
              console.log(2)
              if (new Date(this.minDate.replace(/-/g, '/')).getTime() >= new Date(this.chooseSelectDate.replace(/-/g, '/')).getTime()) {
                this.$commonJs.alertTips({
                  type: 'warning',
                  title: '提示',
                  content: '结束时间不能小于开始时间',
                  stayTime: 5
                })
                return
              }
            }
          }
        }
        if (new Date(this.chooseSelectDate2).getTime() > new Date(this.chooseSelectDate).getTime()) {
          this.$emit('fatherDate', [this.chooseSelectDate, this.chooseSelectDate2])
        } else {
          this.$emit('fatherDate', [this.chooseSelectDate2, this.chooseSelectDate])
        }
        this.$emit('chooseComplete', [this.chooseSelectDate, this.chooseSelectDate2])
        document.getElementById(this.randomId).style.display = 'none'
        document.getElementById(this.randomId + '2').style.display = 'none'
      } else {
        if ((!this.chooseSelectDate && this.chooseSelectDate2) || (this.chooseSelectDate && !this.chooseSelectDate2)) {
          this.$commonJs.alertTips({
            type: 'warning',
            title: '提示',
            content: '请选择完整的时间段',
            stayTime: 5
          })
          return
        }
        let year
        let month
        let date
        let year2
        let month2
        let date2
        if (this.newMinDate) {
          year = new Date(this.newMinDate).getFullYear()
          month = new Date(this.newMinDate).getMonth() + 1
          date = new Date(this.newMinDate).getDate()
        } else {
          year = this.nowDate.getFullYear()
          month = this.nowDate.getMonth() + 1 < 10 ? ('0' + (this.nowDate2.getMonth() + 1)) : this.nowDate2.getMonth() + 1
          date = this.nowDate.getDate() < 10 ? '0' + this.nowDate.getDate() : this.nowDate.getDate()
        }
        year2 = this.nowDate2.getFullYear()
        month2 = this.nowDate2.getMonth() + 1 < 10 ? ('0' + (this.nowDate2.getMonth() + 1)) : this.nowDate2.getMonth() + 1
        date2 = this.nowDate2.getDate() < 10 ? '0' + this.nowDate2.getDate() : this.nowDate2.getDate()
        let now = year + '/' + month + '/' + date + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate
        if (this.minDate) {
          if (new Date(this.minDate.replace(/-/g, '/')).getTime() < new Date().getTime()) {
            this.$emit('fatherDate', [this.$commonJs.todayDate + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate, this.$commonJs.todayDate + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate])
            document.getElementById(this.randomId).style.display = 'none'
            document.getElementById(this.randomId + '2').style.display = 'none'
            return
          } else {
            if (this.canNotEqure) {
              console.log(3)
              if (new Date(this.minDate.replace(/-/g, '/')).getTime() > new Date(now.replace(/-/g, '/')).getTime()) {
                this.$commonJs.alertTips({
                  type: 'warning',
                  title: '提示',
                  content: '结束时间不能小于开始时间',
                  stayTime: 5
                })
                return
              }
            } else {
              console.log(4)
              if (new Date(this.minDate.replace(/-/g, '/')).getTime() >= new Date(now.replace(/-/g, '/')).getTime()) {
                this.$commonJs.alertTips({
                  type: 'warning',
                  title: '提示',
                  content: '结束时间不能小于开始时间',
                  stayTime: 5
                })
                return
              }
            }
          }
        }
        if (new Date(year + '/' + month + '/' + date + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate).getTime() > new Date(year2 + '/' + month2 + '/' + date2 + ' ' + this.newHour2 + ':' + this.newMinite2 + ':' + this.newDate2).getTime()) {
          this.$emit('fatherDate', [year2 + '/' + month2 + '/' + date2 + ' ' + this.newHour2 + ':' + this.newMinite2 + ':' + this.newDate2, year + '/' + month + '/' + date + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate])
          this.$emit('chooseComplete', [year2 + '/' + month2 + '/' + date2 + ' ' + this.newHour2 + ':' + this.newMinite2 + ':' + this.newDate2, year + '/' + month + '/' + date + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate])
        } else {
          this.$emit('fatherDate', [year + '/' + month + '/' + date + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate, year2 + '/' + month2 + '/' + date2 + ' ' + this.newHour2 + ':' + this.newMinite2 + ':' + this.newDate2])
          this.$emit('chooseComplete', [year + '/' + month + '/' + date + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate, year2 + '/' + month2 + '/' + date2 + ' ' + this.newHour2 + ':' + this.newMinite2 + ':' + this.newDate2])
        }
        document.getElementById(this.randomId).style.display = 'none'
        document.getElementById(this.randomId + '2').style.display = 'none'
      }
    },
    returnChooseClass (item) {
      if (item.isNow && item.isChoose) {
        return 'chooseDay'
      } else {
        if (item.isNow) {
          return 'nowDay'
        } else if (item.isChoose) {
          return 'chooseDay'
        } else if (item.picked) {
          return 'picked'
        }
      }
    },
    showCanderFun () {
      document.getElementById(this.randomId).style.display = 'block'
      document.getElementById(this.randomId + '2').style.display = 'block'
    },
    removeValue () {
      this.replaceNewDate(null, true)
      this.chooseSelectDate = ''
      this.chooseNowDate2 = ''
      this.chooseNowDate = ''
      this.chooseSelectDate2 = ''
      this.$emit('fatherDate', '')
      for (let i = 0; i < this.dataTimeList.length; i++) {
        this.$set(this.dataTimeList[i], 'picked', false)
      }
      for (let i = 0; i < this.dataTimeList2.length; i++) {
        this.$set(this.dataTimeList2[i], 'picked', false)
      }
    },
    hiddenChoose (e) {
      // const that = this
      // setTimeout(function () {
      //   that.showCander = false
      // }, 100)
    },
    stopShow (e) {
      e.stopPropagation()
    },
    chooseDate (item, index) {
      if (!item.disabled && !item.isLast) {
        if (this.showTimePicker) {
          for (let i = 0; i < this.dataTimeList.length; i++) {
            if (this.dataTimeList[i].isChoose) {
              this.dataTimeList[i].isChoose = false
            }
          }
          this.$set(item, 'isChoose', true)
          let startChooseDate = ''
          let endChooseDate = ''
          for (let i = 0; i < this.dataTimeList.length; i++) {
            this.$set(this.dataTimeList[i], 'picked', false)
            if (this.dataTimeList[i].isChoose) {
              startChooseDate = this.dataTimeList[i].nowDate
            }
          }
          for (let i = 0; i < this.dataTimeList2.length; i++) {
            this.$set(this.dataTimeList2[i], 'picked', false)
            if (this.dataTimeList2[i].isChoose) {
              endChooseDate = this.dataTimeList2[i].nowDate
            }
          }
          if (startChooseDate && endChooseDate) {
            let matchStart = ''
            let matchEnd = ''
            if (new Date(startChooseDate).getTime() < new Date(endChooseDate).getTime()) {
              matchStart = startChooseDate
              matchEnd = endChooseDate
            } else {
              matchStart = endChooseDate
              matchEnd = startChooseDate
            }
            for (let i = 0; i < this.dataTimeList.length; i++) {
              if (new Date(this.dataTimeList[i].nowDate).getTime() >= new Date(matchStart).getTime() && new Date(this.dataTimeList[i].nowDate).getTime() < new Date(matchEnd).getTime() && !this.dataTimeList[i].disabled && !this.dataTimeList[i].isLast) {
                this.$set(this.dataTimeList[i], 'picked', true)
              }
            }
            for (let i = 0; i < this.dataTimeList2.length; i++) {
              if (new Date(this.dataTimeList2[i].nowDate).getTime() < new Date(matchEnd).getTime() && new Date(this.dataTimeList2[i].nowDate).getTime() > new Date(matchStart).getTime() && !this.dataTimeList2[i].disabled && !this.dataTimeList2[i].isLast) {
                this.$set(this.dataTimeList2[i], 'picked', true)
              }
            }
            console.log(this.dataTimeList)
          }
          this.chooseNowDate = item.nowDate
          this.chooseSelectDate = this.chooseNowDate + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate
          // this.replaceNewDate()
          console.log(item)
        } else {
          let nowDate = item.nowDate
          this.$emit('fatherDate', [nowDate, this.fatherDate[1] || ''])
          this.$emit('chooseComplete', [nowDate, this.fatherDate[1] || ''])
          document.getElementById(this.randomId).style.display = 'none'
          document.getElementById(this.randomId + '2').style.display = 'none'
        }
      }
    },
    chooseDate2 (item, index) {
      if (!item.disabled && !item.isLast) {
        if (this.showTimePicker) {
          if (this.chooseNowDate) {
            for (let i = 0; i < this.dataTimeList2.length; i++) {
              if (this.dataTimeList2[i].isChoose) {
                this.dataTimeList2[i].isChoose = false
              }
            }
            this.$set(item, 'isChoose', true)
            let startChooseDate = ''
            let endChooseDate = ''
            for (let i = 0; i < this.dataTimeList.length; i++) {
              this.$set(this.dataTimeList[i], 'picked', false)
              if (this.dataTimeList[i].isChoose) {
                startChooseDate = this.dataTimeList[i].nowDate
              }
            }
            for (let i = 0; i < this.dataTimeList2.length; i++) {
              this.$set(this.dataTimeList2[i], 'picked', false)
              if (this.dataTimeList2[i].isChoose) {
                endChooseDate = this.dataTimeList2[i].nowDate
              }
            }
            if (startChooseDate && endChooseDate) {
              let matchStart = ''
              let matchEnd = ''
              if (new Date(startChooseDate).getTime() < new Date(endChooseDate).getTime()) {
                matchStart = startChooseDate
                matchEnd = endChooseDate
              } else {
                matchStart = endChooseDate
                matchEnd = startChooseDate
              }
              for (let i = 0; i < this.dataTimeList.length; i++) {
                if (new Date(this.dataTimeList[i].nowDate).getTime() > new Date(matchStart).getTime() && new Date(this.dataTimeList[i].nowDate).getTime() < new Date(matchEnd).getTime() && !this.dataTimeList[i].disabled && !this.dataTimeList[i].isLast) {
                  this.$set(this.dataTimeList[i], 'picked', true)
                }
              }
              for (let i = 0; i < this.dataTimeList2.length; i++) {
                console.log(this.dataTimeList2[i].nowDate)
                console.log(endChooseDate)
                if (new Date(this.dataTimeList2[i].nowDate).getTime() > new Date(matchStart).getTime() && new Date(this.dataTimeList2[i].nowDate).getTime() < new Date(matchEnd).getTime() && !this.dataTimeList2[i].disabled && !this.dataTimeList2[i].isLast) {
                  this.$set(this.dataTimeList2[i], 'picked', true)
                }
              }
              console.log(this.dataTimeList)
            }
            this.chooseNowDate2 = item.nowDate
            this.chooseSelectDate2 = this.chooseNowDate2 + ' ' + this.newHour2 + ':' + this.newMinite2 + ':' + this.newDate2
            // this.replaceNewDate()
            console.log(item)
          } else {
            this.$commonJs.alertTips({
              type: 'warning',
              title: '提示',
              content: '请先选择起始日期',
              stayTime: 5
            })
          }
        } else {
          let nowDate = item.nowDate
          this.$emit('fatherDate', [this.fatherDate[0] || '', nowDate])
          this.$emit('chooseComplete', [this.fatherDate[0] || '', nowDate])
          document.getElementById(this.randomId).style.display = 'none'
          document.getElementById(this.randomId + '2').style.display = 'none'
        }
      }
    },
    changeChooseDate () {
      if (this.chooseNowDate) {
        this.chooseSelectDate = this.chooseNowDate + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate
      } else {
        let year
        let month
        let date
        if (this.newMinDate) {
          year = new Date(this.newMinDate).getFullYear()
          month = new Date(this.newMinDate).getMonth() + 1
          date = new Date(this.newMinDate).getDate()
        } else {
          year = this.nowDate.getFullYear()
          month = this.nowDate.getMonth() + 1
          date = this.nowDate.getDate()
        }
        this.chooseSelectDate = year + '/' + month + '/' + date + ' ' + this.newHour + ':' + this.newMinite + ':' + this.newDate
      }
    },
    changeChooseDate2 () {
      if (this.chooseNowDate2) {
        this.chooseSelectDate2 = this.chooseNowDate2 + ' ' + this.newHour2 + ':' + this.newMinite2 + ':' + this.newDate2
      } else {
        let year
        let month
        let date
        if (this.newMinDate) {
          year = new Date(this.newMinDate).getFullYear()
          month = new Date(this.newMinDate).getMonth() + 1
          date = new Date(this.newMinDate).getDate()
        } else {
          year = this.nowDate2.getFullYear()
          month = this.nowDate2.getMonth() + 1
          date = this.nowDate2.getDate()
        }
        this.chooseSelectDate2 = year + '/' + month + '/' + date + ' ' + this.newHour2 + ':' + this.newMinite2 + ':' + this.newDate2
      }
    },
    prevMonth () {
      let year = this.nowDate.getFullYear()
      let month = this.nowDate.getMonth()
      month = month === 0 ? 12 : month
      year = month === 12 ? year - 1 : year
      const date = this.nowDate.getDate()
      this.replaceNewDate(year + '/' + month + '/' + date)
    },
    nextMonth () {
      // if (this.nowDate2.getFullYear() <= this.nowDate.getFullYear()) {
      //   return
      // } else {
      //   if (Math.abs(this.nowDate2.getFullYear() - this.nowDate.getFullYear()) === 1 && this.nowMonth2 <= this.nowMonth) {
      //     return
      //   }
      // }
      let year = this.nowDate.getFullYear()
      let month = this.nowDate.getMonth() + 2
      month = month === 13 ? 1 : month
      year = month === 1 ? year + 1 : year
      const date = this.nowDate.getDate()
      this.replaceNewDate(year + '/' + month + '/' + date)
    },
    prevYear () {
      const year = this.nowDate.getFullYear() - 1
      const month = this.nowDate.getMonth() + 1
      const date = this.nowDate.getDate()
      this.replaceNewDate(year + '/' + month + '/' + date)
    },
    nextYear () {
      if (this.nowDate2.getFullYear() <= this.nowDate.getFullYear()) {
        return
      } else {
        if (Math.abs(this.nowDate2.getFullYear() - this.nowDate.getFullYear()) === 1 && this.nowMonth2 < this.nowMonth) {
          return
        }
      }
      const year = this.nowDate.getFullYear() + 1
      const month = this.nowDate.getMonth() + 1
      const date = this.nowDate.getDate()
      this.replaceNewDate(year + '/' + month + '/' + date)
    },
    prevMonth2 () {
      // if (this.nowDate2.getFullYear() <= this.nowDate.getFullYear()) {
      //   return
      // } else {
      //   if (Math.abs(this.nowDate2.getFullYear() - this.nowDate.getFullYear()) === 1 && this.nowMonth2 < this.nowMonth) {
      //     return
      //   }
      // }
      let year = this.nowDate2.getFullYear()
      let month = this.nowDate2.getMonth()
      month = month === 0 ? 12 : month
      year = month === 12 ? year - 1 : year
      const date = this.nowDate2.getDate()
      this.replaceNewDate2(year + '/' + month + '/' + date)
    },
    nextMonth2 () {
      let year = this.nowDate2.getFullYear()
      let month = this.nowDate2.getMonth() + 2
      month = month === 13 ? 1 : month
      year = month === 1 ? year + 1 : year
      const date = this.nowDate2.getDate()
      this.replaceNewDate2(year + '/' + month + '/' + date)
    },
    prevYear2 () {
      if (this.nowDate2.getFullYear() <= this.nowDate.getFullYear()) {
        return
      } else {
        if (Math.abs(this.nowDate2.getFullYear() - this.nowDate.getFullYear()) === 1 && this.nowMonth2 < this.nowMonth) {
          return
        }
      }
      const year = this.nowDate2.getFullYear() - 1
      const month = this.nowDate2.getMonth() + 1
      const date = this.nowDate2.getDate()
      this.replaceNewDate2(year + '/' + month + '/' + date)
    },
    nextYear2 () {
      const year = this.nowDate2.getFullYear() + 1
      const month = this.nowDate2.getMonth() + 1
      const date = this.nowDate2.getDate()
      this.replaceNewDate2(year + '/' + month + '/' + date)
    },
    replaceNewDate (date, first) {
      // this.chooseNowDate = ''
      this.dataTimeList = []
      let nowDate = new Date()
      if (date) {
        nowDate = new Date(date.replace(/-/g, '/'))
      }
      this.nowDate = nowDate
      const year = nowDate.getFullYear()
      const month = nowDate.getMonth() + 1
      // const day = nowDate.getDate()
      this.nowYear = year
      this.nowMonth = month < 10 ? '0' + month : month
      const week = new Date(year + '/' + month + '/' + 1).getDay()
      let num = 1
      let lastNum = 1
      console.log(this.returnMaxMonth(year, month))
      for (let i = 0; i < 42; i++) {
        let data = {
          nowNum: '',
          nowDate: '',
          isNow: false,
          isLast: false,
          disabled: false,
          picked: false
        }
        if (i < week) {
          data.isLast = true
          if (month === 1) {
            data.nowDate = (year - 1) + '/' + 12 + '/' + (this.returnMaxMonth(year - 1, 12) - week + i + 1)
            data.nowNum = this.returnMaxMonth(year - 1, 12) - week + i + 1
          } else {
            data.nowDate = year + '/' + (month - 1) + '/' + (this.returnMaxMonth(year, month - 1) - week + i + 1)
            data.nowNum = this.returnMaxMonth(year, month - 1) - week + i + 1
          }
        } else if (num > this.returnMaxMonth(year, month)) {
          data.isLast = true
          if (month === 12) {
            data.nowDate = (year + 1) + '/' + 1 + '/' + lastNum
            data.nowNum = lastNum
          } else {
            data.nowDate = year + '/' + (month + 1) + '/' + lastNum
            data.nowNum = lastNum
          }
          lastNum++
        } else {
          data.nowDate = year + '/' + month + '/' + num
          data.nowNum = num
          if (new Date().getFullYear() === year && new Date().getMonth() + 1 === month && new Date().getDate() === num) {
            data.isNow = true
          }
          num++
        }
        if (this.newMinDate) {
          if (new Date(data.nowDate.replace(/-/g, '/')).getTime() < new Date(this.newMinDate.replace(/-/g, '/')).getTime() - (24 * 60 * 60 * 1000) + 1) {
            data.disabled = true
          }
        }
        this.dataTimeList.push(data)
      }
      let newYear = nowDate.getFullYear()
      let newMonth = nowDate.getMonth() + 2
      let newDate = nowDate.getDate()
      if (newMonth > 12) {
        newMonth = 1
        newYear++
      }
      if (this.chooseNowDate && this.chooseNowDate2) {
        let matchStart = ''
        let matchEnd = ''
        if (new Date(this.chooseNowDate).getTime() < new Date(this.chooseNowDate2).getTime()) {
          matchStart = this.chooseNowDate
          matchEnd = this.chooseNowDate2
        } else {
          matchStart = this.chooseNowDate2
          matchEnd = this.chooseNowDate
        }
        for (let i = 0; i < this.dataTimeList.length; i++) {
          if (new Date(this.dataTimeList[i].nowDate).getTime() >= new Date(matchStart).getTime() - 100000 && new Date(this.dataTimeList[i].nowDate).getTime() < new Date(matchEnd).getTime() + 100000 && !this.dataTimeList[i].disabled && !this.dataTimeList[i].isLast) {
            this.$set(this.dataTimeList[i], 'picked', true)
          }
        }
      }
      if (first) {
        this.replaceNewDate2(newYear + '/' + newMonth + '/' + newDate)
      }
      this.canclick = !(this.nowYear === this.nowYear2 && this.nowMonth === this.nowMonth2)
    },
    replaceNewDate2 (date) {
      // this.chooseNowDate = ''
      this.dataTimeList2 = []
      let nowDate = new Date()
      if (date) {
        nowDate = new Date(date.replace(/-/g, '/'))
      }
      this.nowDate2 = nowDate
      const year = nowDate.getFullYear()
      const month = nowDate.getMonth() + 1
      // const day = nowDate.getDate()
      this.nowYear2 = year
      this.nowMonth2 = month < 10 ? '0' + month : month
      const week = new Date(year + '/' + month + '/' + 1).getDay()
      let num = 1
      let lastNum = 1
      for (let i = 0; i < 42; i++) {
        let data = {
          nowNum: '',
          nowDate: '',
          isNow: false,
          picked: false,
          isLast: false,
          disabled: false
        }
        if (i < week) {
          data.isLast = true
          if (month === 1) {
            data.nowDate = (year - 1) + '/' + 12 + '/' + (this.returnMaxMonth(year - 1, 12) - week + i + 1)
            data.nowNum = this.returnMaxMonth(year - 1, 12) - week + i + 1
          } else {
            data.nowDate = year + '/' + (month - 1) + '/' + (this.returnMaxMonth(year, month - 1) - week + i + 1)
            data.nowNum = this.returnMaxMonth(year, month - 1) - week + i + 1
          }
        } else if (num > this.returnMaxMonth(year, month)) {
          data.isLast = true
          if (month === 12) {
            data.nowDate = (year + 1) + '/' + 1 + '/' + lastNum
            data.nowNum = lastNum
          } else {
            data.nowDate = year + '/' + (month + 1) + '/' + lastNum
            data.nowNum = lastNum
          }
          lastNum++
        } else {
          data.nowDate = year + '/' + month + '/' + num
          data.nowNum = num
          if (new Date().getFullYear() === year && new Date().getMonth() + 1 === month && new Date().getDate() === num) {
            data.isNow = true
          }
          num++
        }
        if (this.newMinDate) {
          if (new Date(data.nowDate.replace(/-/g, '/')).getTime() < new Date(this.newMinDate.replace(/-/g, '/')).getTime() - (24 * 60 * 60 * 1000) + 1) {
            data.disabled = true
          }
        }
        this.dataTimeList2.push(data)
      }
      if (this.chooseNowDate && this.chooseNowDate2) {
        for (let i = 0; i < this.dataTimeList2.length; i++) {
          if (new Date(this.dataTimeList2[i].nowDate).getTime() > new Date(this.chooseNowDate).getTime() - 100000 && new Date(this.dataTimeList2[i].nowDate).getTime() < new Date(this.chooseNowDate2).getTime() + 100000 && !this.dataTimeList2[i].disabled && !this.dataTimeList2[i].isLast) {
            this.$set(this.dataTimeList2[i], 'picked', true)
          }
        }
      }
      // console.log(this.nowYear === this.nowYear2)
      // console.log(this.nowMonth === this.nowMonth2)
      // console.log(this.nowDate === this.nowDate2)
      this.canclick = !(this.nowYear === this.nowYear2 && this.nowMonth === this.nowMonth2)
    },
    returnMaxMonth (year, month) {
      if ([1, 3, 5, 7, 8, 10, 12].indexOf(month) >= 0) {
        return 31
      }
      if ([4, 6, 9, 11].indexOf(month) >= 0) {
        return 30
      }
      if (month === 2) {
        if (year % 4 === 0) {
          return 29
        } else {
          return 28
        }
      }
    }
  },
  components: {
  },
  computed: {
  }
}
</script>

<style scoped>
  .canderInput{
    position: relative;
    width: 100%;
  }
  .canderInput .canderInputPlace:hover b{
    display: inline-block;
  }
  .canderInput .canderInputPlace{
    display: flex;
    align-items: center;
  }
  .canderInput .canderInputPlace b{
    position: absolute;
    right: 10px;
    top: 8px;
    cursor: pointer;
    display: none;
  }
  .canderDiv{
    display: none;
    position: absolute;
    z-index: 999;
    width: 210px;
    background: #fff;
    border:none;
  }
  .canderHeader{
    user-select: none;
    text-align: center;
    padding: 5px;
    border-bottom: 1px solid #f1f1f1;
    white-space: nowrap;
  }
  .canderHeader span{
    margin: 0px 6px;
    cursor: pointer;
    color: #666;
  }
  .canderHeader span b{
    font-family: "微软雅黑", "Arial";
    font-size: 8px;
  }
  .canderBody{
    text-align: center;
  }
  .canderBody span{
    display: inline-block;
    width: 23px;
    margin: 2px;
    height: 23px;
    line-height: 23px;
    border-radius: 2px;
    cursor: pointer;
    transition: all 0.2s;
  }
  .canderBodyDate{
    white-space: normal;
  }
  .canderBodyDate span.nowDay {
    background: #d2e9f3;
    color: #fff;
  }
  .canderBodyDate span.chooseDay {
    background: #FF8144!important;
    color: #fff;
  }
  .canderBodyDate span.picked {
    background: #EFA868!important;
    color: #fff;
  }
  .canderBodyDate span:disabled{
    background: #eee!important;
  }
  .canderBody .canderBodyDate span:hover{
    background: #408DEB;
    color: #fff;
  }
  .showTimePlace{
    margin: 10px 5px;
  }
  .showTimePlace select{
    width: 30%;
    border: 1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/canderReigon.vue